import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/ranges.js'
import flatpickr from 'flatpickr';
import StylesControl from "mapbox-gl-controls/lib/styles";

import buffer from '@turf/buffer';
import {featureCollection, lineString, point, polygon} from '@turf/helpers';
import bbox from '@turf/bbox';
import center from '@turf/center';

import JsonViewer from 'json-viewer-js';

window.StylesControl = StylesControl;
window.TurfPoint = point;
window.TurfBounds = bbox;
window.TurfLineString = lineString;
window.TurfBuffer = buffer;
window.TurfCenter = center;
window.TurfFeatureCollection = featureCollection;
window.TurfPolygon = polygon;

window.Vapor = require('laravel-vapor');
window.axios = require('axios').default;

import Inputmask from "inputmask";

window.JsonViewer = JsonViewer;

window.naturalCompare = require('string-natural-compare');

window.querySelector = document.querySelector.bind(document);
window.querySelectorAll = document.querySelectorAll.bind(document);
